import { Heart } from "lucide-react";
import { useWishlist } from "../context/WishlistContext";
import { toast } from "sonner";

/**
 * Heart icon toggle for wishlist.
 * Props:
 * - productId: string
 * - productName: string (for toast)
 * - className: extra classes for the button wrapper
 * - size: icon px size
 */
export default function WishlistButton({
  productId,
  productName = "Article",
  className = "",
  size = 18,
}) {
  const { has, toggle } = useWishlist();
  const active = has(productId);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(productId);
    toast.success(
      active
        ? `${productName} retiré des favoris`
        : `${productName} ajouté aux favoris`
    );
  };

  return (
    <button
      onClick={onClick}
      aria-label={active ? "Retirer des favoris" : "Ajouter aux favoris"}
      aria-pressed={active}
      data-testid={`wishlist-toggle-${productId}`}
      className={`inline-flex items-center justify-center p-2 transition-all ${
        active
          ? "bg-white text-[#FF6B6B]"
          : "bg-[#001F3F]/80 backdrop-blur-sm text-white hover:bg-white hover:text-[#FF6B6B]"
      } ${className}`}
    >
      <Heart
        size={size}
        strokeWidth={1.5}
        className={active ? "fill-current" : ""}
      />
    </button>
  );
}
